import { createAction } from 'redux-actions';

export const userCarFetch = createAction('USER_DASHBOARD_USER_CAR_FETCH');
export const userCarSet = createAction('USER_DASHBOARD_USER_CAR_SET');
